import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from "vue";
import { ILineInfoData, ILineInfoLite } from "@/domain/entities/lineInfo";
import useGetLineRouteName from "@/use/useGetLineRouteName";
import BookChip from "../shared/chip/BookChip.vue";
import CheckboxInput from "../shared/inputs/CheckboxInput.vue";
import LineSetTypeChip from "../shared/chip/LineSetTypeChip.vue";
import { IBusStopData } from "@/domain/entities/busStop";
import { LineTypeCode } from "@/types";


const __default__ = {
  name: "LineInfoRow",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  lineInfo: {
    type: Object as PropType<ILineInfoData | ILineInfoLite>,
    required: true,
  },
  busStop: {
    type: Object as PropType<IBusStopData>,
  },
  checkedLineIds: {
    type: Array as PropType<string[]>,
    default: () => [],
  },
  // 리뷰용 화면에서는 요금 제거
  shouldHideFare: {
    type: Boolean,
    default: false,
  },
  shouldShowCheckBox: {
    type: Boolean,
    default: false,
  },
  isPossibleToCheckLine: {
    type: Boolean,
    default: true,
  },
},
  emits: ["onChangedCheck"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const busStopTimes = computed(() => {
  // Inside(사내셔틀)인 경우 빈 문자열 반환
  if (props.lineInfo.lineTypeCode === LineTypeCode.Inside) {
    return "";
  }

  // ILineInfoData인 경우 빈 문자열 반환 (ILineInfoLite만 처리)
  if (!("stations" in props.lineInfo.turns[0])) {
    return "";
  }

  // ILineInfoLite인 경우에만 처리
  const lineInfoLite = props.lineInfo as ILineInfoLite;
  return lineInfoLite.turns
    .map((turn) => {
      // 이 회차에서 gateNoList가 있는 정류장들을 정류장 순서대로 찾기
      const stationsWithGates = turn.stations
        ?.filter((station) => station.gateNoList && station.gateNoList.trim())
        .map((station) => station.gateNoList) // 이미 파서에서 압축 처리됨
        .filter((gates) => gates); // 빈 문자열 제거

      // 시간 표시
      let timeDisplay = turn.beginStationDepartureTime || "";

      // 게이트 정보가 있으면 추가
      if (stationsWithGates && stationsWithGates.length > 0) {
        const gateInfo = stationsWithGates.join("/");
        timeDisplay += `(${gateInfo})`;
      }

      return timeDisplay;
    })
    .filter((time) => time) // 빈 문자열 제거
    .join(" / ");
});

const emitOnChangedCheck = (lineInfoId?: string) => {
  if (!lineInfoId) return;

  emit("onChangedCheck", lineInfoId);
};

const checked = computed(() => isCheckedLine(props.lineInfo.id));

const isCheckedLine = (targetId?: string) => {
  if (!targetId) return false;

  return props.checkedLineIds.some((id) => id === targetId);
};

const disabledCheckBox = computed(
  () => !checked.value && !props.isPossibleToCheckLine
);

// 노선 금액을 보여주려면 아래 주석 활성화
// const dailyFare = computed(() => props.lineInfo.turns[0].lineFare.dailyFare);
// const monthlyFare = computed(
//   () => props.lineInfo.turns[0].lineFare.monthlyFare
// );

// 노선에 예약 가능한 회차가 하나라도 있으면 예약 칩을 보여준다.
const shouldShowBookChip = computed(() =>
  props.lineInfo.turns.some((turn) => turn.bookYn)
);

const __returned__ = { props, emit, busStopTimes, emitOnChangedCheck, checked, isCheckedLine, disabledCheckBox, shouldShowBookChip, get useGetLineRouteName() { return useGetLineRouteName }, BookChip, CheckboxInput, LineSetTypeChip }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})